import React from 'react'
import { PageProps } from 'gatsby'

// Lazy loading
import loadable from '@loadable/component'

export interface VacanciesProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Vacancies
  location?: PageProps['location']
  slider?: boolean
  node?: {
    id: string
    title: string
    uri: string
    recap: {
      location: string
      hours: string
      level: string
      excerpt: string
    }
  }
}

interface VacancyProps {
  [key: string]: any
}

const VacanciesShell: React.FC<VacanciesProps> = ({ fields, location }) => {
  const types: VacancyProps = {
    overview: loadable(() => import('components/flex/Vacancies/Overview')),
    embedded: loadable(() => import('components/flex/Vacancies/Embedded')),
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default VacanciesShell
